module.exports = __webpack_public_path__ + "static/img/graph_icon.d0bd90f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/graph_icon.png
// module id = f4SV
// module chunks = 53